import { render, staticRenderFns } from "./tag-input.generic.vue?vue&type=template&id=d1348cc8&scoped=true&"
import script from "./tag-input.generic.vue?vue&type=script&lang=js&"
export * from "./tag-input.generic.vue?vue&type=script&lang=js&"
import style0 from "./tag-input.generic.vue?vue&type=style&index=0&id=d1348cc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1348cc8",
  null
  
)

export default component.exports